"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
/**
 * Singleton to hold context props for the environment the app is running in
 * Note: requires window.env.ENV object to be set in the browser
 * @returns {object}
 */
var Env = /*#__PURE__*/_createClass(function Env() {
  _classCallCheck(this, Env);
  if (!Env.instance) {
    var isClient = typeof window !== 'undefined';
    var env = isClient && window.env && window.env.ENV || {};
    Env.instance = {
      isClient: isClient,
      isClientLocal: isClient && env === 'local',
      isClientDev: isClient && env === 'dev',
      isClientTest: isClient && env === 'test',
      isClientProd: isClient && env === 'prod',
      isClientNonProd: isClient && (env === 'local' || env === 'dev' || env === 'test')
    };
  }
  return Env.instance;
});
var _default = exports["default"] = new Env();